<template>
  <div class="max-w-3xl mx-auto px-4 md:px-10 py-6 space-y-8">
    <h2 class="text-2xl md:text-4xl font-bold text-gray-800 border-b-4 border-emerald-500">
      Todoについて
    </h2>

    <p class="text-sm md:text-base">
      だれでも使用できるTodoリストです。<br />
      Googleアカウントでログインできます。
    </p>

    <h2 class="text-2xl md:text-4xl font-bold text-gray-800 border-b-4 border-emerald-500">
      使用言語
    </h2>

    <p class="text-sm md:text-base">Vue.js、Tailwind CSS、Supabase</p>
  </div>
</template>
